"use strict";
/**
 * Identidade da marca isolada em um único ponto.
 *
 * Nome, cores, domínio e textos legais podem mudar sem tocar em nenhuma regra
 * de negócio: tudo que é visual/textual referencia `BRAND`, e o restante do
 * código nunca escreve "NossoRachão" literalmente.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_DOCUMENT_VERSIONS = exports.DEFAULT_BRAND = void 0;
exports.resolveBrand = resolveBrand;
exports.DEFAULT_BRAND = {
    name: 'NossoRachão',
    shortName: 'NossoRachao',
    tagline: 'Sua pelada organizada de ponta a ponta',
    supportEmail: 'suporte@escalae.app',
    websiteUrl: 'https://escalae.com.br',
    appUrl: 'https://app.escalae.com.br',
    deeplinkScheme: 'escalae',
    legalEntity: 'NossoRachão Tecnologia',
    dataControllerEmail: 'privacidade@escalae.app',
    colors: {
        primary: '#12B76A',
        primaryDark: '#039855',
        secondary: '#0B1B2B',
        accent: '#F79009',
    },
};
/**
 * Resolve a marca a partir do ambiente, caindo no padrão quando não definida.
 * Aceita `Record<string, string | undefined>` para funcionar tanto com
 * `process.env` (API) quanto com as constantes do Expo (mobile).
 */
function resolveBrand(env = {}) {
    return {
        ...exports.DEFAULT_BRAND,
        name: env.BRAND_NAME ?? exports.DEFAULT_BRAND.name,
        shortName: env.BRAND_SHORT_NAME ?? exports.DEFAULT_BRAND.shortName,
        supportEmail: env.BRAND_SUPPORT_EMAIL ?? exports.DEFAULT_BRAND.supportEmail,
        appUrl: env.APP_PUBLIC_URL ?? exports.DEFAULT_BRAND.appUrl,
        deeplinkScheme: env.APP_DEEPLINK_SCHEME ?? exports.DEFAULT_BRAND.deeplinkScheme,
    };
}
/** Versão vigente dos documentos legais — registrada em cada consentimento. */
exports.LEGAL_DOCUMENT_VERSIONS = {
    TERMS_OF_USE: '2026-01-01',
    PRIVACY_POLICY: '2026-01-01',
};
//# sourceMappingURL=brand.js.map